// extracted by mini-css-extract-plugin
export default {"wrapper":"ProfileLayout_wrapper__p0ieb","content":"ProfileLayout_content__mGkru"};